import { render } from "./PortfolioScreen.vue?vue&type=template&id=35217d64&scoped=true"
import script from "./PortfolioScreen.vue?vue&type=script&lang=js"
export * from "./PortfolioScreen.vue?vue&type=script&lang=js"

import "./PortfolioScreen.vue?vue&type=style&index=0&id=35217d64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35217d64"]])

export default __exports__